/**
 * DILEMMA — Custom Product Pricing Display + Free Shipping Preview
 * -----------------------------------------------------------------
 * Listens to variant picker, Seal Subscriptions events, and quantity changes.
 * Updates custom pricing display and free shipping bar in real-time.
 */

(function () {
  'use strict';

  /* ═══════════════════════════════════════════
     PRICING MAP
     ═══════════════════════════════════════════ */

  /* ── Detect which product we're on ── */
  var productInfoEl = document.querySelector('product-info[data-product-handle]');
  var productHandle = productInfoEl ? productInfoEl.getAttribute('data-product-handle') : '';
  var isRitualSystem = (productHandle === 'dilemma-foundation-starter-system');

  /* ── Foundation pricing ── */
  var foundationPricingMap = {
    '1 Pack': {
      oneTime: 79, oneTimeCompare: null, oneTimeSavings: null,
      subscribe: 69, subscribeCompare: null, subscribeSavings: 10,
      delivery: 'Delivered monthly'
    },
    '2 Pack - Save 10% (Most Popular)': {
      oneTime: 139, oneTimeCompare: 158, oneTimeSavings: 19,
      subscribe: 129, subscribeCompare: 158, subscribeSavings: 29,
      delivery: 'Delivered every 2 months'
    },
    '3 Pack - Save 15% (Best Value)': {
      oneTime: 199, oneTimeCompare: 237, oneTimeSavings: 38,
      subscribe: 189, subscribeCompare: 237, subscribeSavings: 48,
      delivery: 'Delivered every 3 months'
    },
    /* Simplified variant names (after manual label cleanup) */
    '2 Pack': {
      oneTime: 139, oneTimeCompare: 158, oneTimeSavings: 19,
      subscribe: 129, subscribeCompare: 158, subscribeSavings: 29,
      delivery: 'Delivered every 2 months'
    },
    '3 Pack': {
      oneTime: 199, oneTimeCompare: 237, oneTimeSavings: 38,
      subscribe: 189, subscribeCompare: 237, subscribeSavings: 48,
      delivery: 'Delivered every 3 months'
    }
  };

  /* ── Ritual System pricing ── */
  var ritualSystemPricingMap = {
    '1 Pack': {
      oneTime: 95, oneTimeCompare: null, oneTimeSavings: null,
      subscribe: 85, subscribeCompare: null, subscribeSavings: 10,
      delivery: 'Delivered monthly'
    }
  };

  var pricingMap = isRitualSystem ? ritualSystemPricingMap : foundationPricingMap;

  var FREE_SHIPPING_THRESHOLD = 100; // dollars

  /* ═══════════════════════════════════════════
     STATE
     ═══════════════════════════════════════════ */

  var state = {
    selectedPack: '1 Pack',
    purchaseType: 'one_time',
    quantity: 1
  };

  /* ═══════════════════════════════════════════
     HELPERS
     ═══════════════════════════════════════════ */

  function formatMoney(amount) {
    if (amount === null || amount === undefined) return '';
    var str = amount.toFixed(2);
    if (str.endsWith('.00')) return '$' + str.slice(0, -3);
    return '$' + str;
  }

  function isVisible(el) {
    /* Skip radios inside the hidden "old" node left by the theme's
       double-buffer viewTransition (display:none parent). */
    var n = el;
    while (n) {
      if (n.style && n.style.display === 'none') return false;
      n = n.parentElement;
    }
    return true;
  }

  function detectSelectedPack() {
    var radios = document.querySelectorAll('.product-form__input input[type="radio"]:checked');
    console.log('[DILEMMA DEBUG] detectSelectedPack — checked radios found:', radios.length);
    for (var i = 0; i < radios.length; i++) {
      var vis = isVisible(radios[i]);
      var val = (radios[i].value || '').trim();
      console.log('[DILEMMA DEBUG]   radio[' + i + '] value="' + val + '" visible=' + vis + ' exactMatch=' + !!pricingMap[val]);
      if (!vis) continue;
      if (pricingMap[val]) return val;
    }
    var selects = document.querySelectorAll('.product-form__input select');
    for (var j = 0; j < selects.length; j++) {
      if (!isVisible(selects[j])) continue;
      var sval = (selects[j].value || '').trim();
      if (pricingMap[sval]) return sval;
    }
    // Fuzzy fallback — only visible radios
    for (var k = 0; k < radios.length; k++) {
      if (!isVisible(radios[k])) continue;
      var v = (radios[k].value || '').toLowerCase();
      console.log('[DILEMMA DEBUG]   fuzzy check: "' + v + '"');
      if (v.indexOf('3 pack') !== -1) return '3 Pack - Save 15% (Best Value)';
      if (v.indexOf('2 pack') !== -1) return '2 Pack - Save 10% (Most Popular)';
      if (v.indexOf('1 pack') !== -1) return '1 Pack';
    }
    console.log('[DILEMMA DEBUG]   FALLBACK → 1 Pack');
    return '1 Pack';
  }

  function detectPurchaseType() {
    var planInputs = document.querySelectorAll('input[name="selling_plan"]');
    for (var i = 0; i < planInputs.length; i++) {
      var val = planInputs[i].value;
      if (planInputs[i].type === 'hidden' && val && val !== '' && val !== '0') return 'subscribe';
      if (planInputs[i].checked && val && val !== '') return 'subscribe';
    }
    return 'one_time';
  }

  function detectQuantity() {
    // Check quantity input inside the product form
    var qtyInput = document.querySelector('.product-form__quantity input[type="number"], input[name="quantity"], .quantity__input');
    if (qtyInput) {
      var val = parseInt(qtyInput.value);
      // Allow 0 — needed for free shipping reset and add-to-cart guard
      if (!isNaN(val) && val >= 0) return val;
    }
    return 1;
  }

  function getCurrentUnitPrice() {
    var data = pricingMap[state.selectedPack];
    if (!data) data = pricingMap['1 Pack'];
    return state.purchaseType === 'subscribe' ? data.subscribe : data.oneTime;
  }

  /* Returns the selected flavor option value (e.g. "Wondermelon", "Peach Mango").
     Pack/unit/supply radios are excluded — everything else is treated as flavor. */
  function detectFlavorName() {
    var radios = document.querySelectorAll('.product-form__input input[type="radio"]:checked');
    for (var i = 0; i < radios.length; i++) {
      if (!isVisible(radios[i])) continue;
      var val = (radios[i].value || '').trim();
      if (pricingMap[val]) continue;
      if (/\bpack\b|\bunit\b|\bsupply\b/i.test(val)) continue;
      if (val) return val;
    }
    return '';
  }

  function detectFlavorSelected() {
    return detectFlavorName() !== '';
  }

  /* Reads the Seal Subscriptions interval dropdown/select to build
     Ritual System delivery text: "Refill delivered monthly" etc. */
  function detectRitualDeliveryText() {
    /* Seal renders a <select> for delivery interval — look for it */
    var selects = document.querySelectorAll('.seal-subs-widget select, [data-sealsubs] select, .shopify-app-block select');
    for (var i = 0; i < selects.length; i++) {
      var val = (selects[i].value || '').toLowerCase();
      /* Seal values are typically like "1 month", "2 months", "3 months" or similar */
      var match = val.match(/(\d+)\s*month/);
      if (match) {
        var months = parseInt(match[1]);
        if (months === 1) return 'Refill delivered monthly';
        return 'Refill delivered every ' + months + ' months';
      }
    }
    /* Fallback: check the selected option text inside Seal widget */
    var selectedOption = document.querySelector('.seal-subs-widget select option:checked, [data-sealsubs] select option:checked, .shopify-app-block select option:checked');
    if (selectedOption) {
      var text = (selectedOption.textContent || '').toLowerCase();
      var textMatch = text.match(/(\d+)\s*month/);
      if (textMatch) {
        var m = parseInt(textMatch[1]);
        if (m === 1) return 'Refill delivered monthly';
        return 'Refill delivered every ' + m + ' months';
      }
      /* Check for "every X weeks" pattern */
      var weekMatch = text.match(/(\d+)\s*week/);
      if (weekMatch) {
        var w = parseInt(weekMatch[1]);
        if (w === 4) return 'Refill delivered monthly';
        return 'Refill delivered every ' + w + ' weeks';
      }
    }
    /* Default fallback */
    return 'Refill delivered monthly';
  }

  /* ═══════════════════════════════════════════
     FLAVOR PROFILE DESCRIPTIONS
     ═══════════════════════════════════════════ */

  var flavorProfiles = {
    'Wondermelon': {
      emphasis: 'Light & refreshing.',
      detail: 'Tastes like ripe watermelon with a soft citrus brightness.'
    },
    'Peach Mango': {
      emphasis: 'Smooth & vibrant.',
      detail: 'Tastes like freshly picked peach with mellow tropical mango.'
    },
    'Cucumber Lemon': {
      emphasis: 'Clean & crisp.',
      detail: 'Tastes like cool cucumber with bright lemon and a fresh finish.'
    }
  };

  function updateFlavorProfile() {
    var container = document.getElementById('dilemma-flavor-profile');
    if (!container) return;
    var textEl = container.querySelector('.dilemma-flavor-profile__text');
    if (!textEl) return;

    var flavor = detectFlavorName();
    var profile = flavorProfiles[flavor];

    if (profile) {
      textEl.innerHTML = '<strong>' + profile.emphasis + '</strong> ' + profile.detail;
      container.style.display = '';
    } else {
      container.style.display = 'none';
    }
  }

  /* Updates the product H1 title flavor span (works for Foundation + Ritual System) */
  function updateProductTitle() {
    var span = document.getElementById('dilemma-title-flavor');
    if (!span) return;
    var flavor = detectFlavorName();
    if (flavor) {
      span.textContent = flavor;
      /* Sync breadcrumb flavor */
      var bcFlav = document.getElementById('dilemma-breadcrumb-flavor');
      if (bcFlav) bcFlav.textContent = flavor;
    }
  }

  /* ═══════════════════════════════════════════
     RENDER PRICING
     ═══════════════════════════════════════════ */

  function renderPricing() {
    var container = document.getElementById('dilemma-pricing-display');
    if (!container) return;

    var data = pricingMap[state.selectedPack];
    if (!data) data = pricingMap['1 Pack'];

    var isSub = state.purchaseType === 'subscribe';
    var price    = isSub ? data.subscribe : data.oneTime;
    var compare  = isSub ? data.subscribeCompare : data.oneTimeCompare;
    var savings  = isSub ? data.subscribeSavings : data.oneTimeSavings;

    var currentEl  = container.querySelector('.dilemma-pricing__current');
    var compareEl  = container.querySelector('.dilemma-pricing__compare');
    var saveEl     = container.querySelector('.dilemma-pricing__save-badge');
    var perUnitEl  = container.querySelector('.dilemma-pricing__per-unit');
    var deliveryEl = container.querySelector('.dilemma-pricing__delivery');

    if (currentEl) currentEl.textContent = formatMoney(price);

    if (compareEl) {
      if (compare !== null) {
        compareEl.textContent = formatMoney(compare);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }

    if (saveEl) {
      if (savings !== null && savings > 0) {
        saveEl.textContent = 'Save $' + savings;
        saveEl.style.display = '';
      } else {
        saveEl.style.display = 'none';
      }
    }

    if (perUnitEl) {
      var packMatch = state.selectedPack.match(/^(\d)/);
      var packNum = packMatch ? parseInt(packMatch[1]) : 1;
      perUnitEl.textContent = formatMoney(price / packNum) + ' per unit';
      perUnitEl.style.display = '';
    }

    if (deliveryEl) {
      if (isSub) {
        if (isRitualSystem) {
          deliveryEl.textContent = detectRitualDeliveryText();
        } else {
          deliveryEl.textContent = data.delivery;
        }
        deliveryEl.style.display = '';
      } else {
        deliveryEl.style.display = 'none';
      }
    }

    /* Benefit chips always visible */
    var perksEl = document.querySelector('.dilemma-sub-perks');
    if (perksEl) perksEl.style.display = '';
  }

  /* ═══════════════════════════════════════════
     RENDER PACK + SUBSCRIPTION PILLS
     Generic toggle for pills that appear next to the save-badge when:
       1. a flavor is selected, AND
       2. a specific pack is selected (via packRegex), AND
       3. Subscribe & Save is active.
     Used for "Most Popular" (2-pack) and "Best Value" (3-pack).
     Mutually exclusive by design — state.selectedPack is a single value.
     ═══════════════════════════════════════════ */

  function renderPackSubPill(selector, packRegex) {
    var pill = document.querySelector(selector);
    if (!pill) return;

    var isSub = state.purchaseType === 'subscribe';
    var show = state.flavorSelected && isSub && packRegex.test(state.selectedPack);

    pill.style.display = show ? '' : 'none';
  }

  /* ═══════════════════════════════════════════
     RENDER FREE SHIPPING PREVIEW
     ═══════════════════════════════════════════ */

  function renderFreeShipping() {
    var bar = document.querySelector('#product-free-shipping free-shipping-bar, free-shipping-bar');
    if (!bar) return;

    var unitPrice = getCurrentUnitPrice();
    var subtotal = unitPrice * state.quantity;
    var remaining = Math.max(0, FREE_SHIPPING_THRESHOLD - subtotal);
    var pct = Math.min(Math.ceil((subtotal / FREE_SHIPPING_THRESHOLD) * 100), 100);

    // When quantity is 0, force everything to zero state
    if (state.quantity === 0) {
      pct = 0;
      remaining = FREE_SHIPPING_THRESHOLD;
    }

    var wrapper    = bar.querySelector('.free-shipping__wrapper');
    var fill       = bar.querySelector('.free-shipping__fill');
    var diffEl     = bar.querySelector('.free-shipping__diff');
    var inactiveEl = bar.querySelector('.free-shipping__inactive');
    var activeEl   = bar.querySelector('.free-shipping__active');

    if (!wrapper) return;

    // Update progress bar width
    if (fill) fill.style.width = pct + '%';

    if (pct >= 100 && state.quantity > 0) {
      // Threshold met
      if (activeEl) activeEl.style.display = 'block';
      if (inactiveEl) inactiveEl.style.display = 'none';
    } else {
      // Below threshold or qty = 0
      if (inactiveEl) {
        if (state.quantity === 0) {
          inactiveEl.textContent = "You're " + formatMoney(FREE_SHIPPING_THRESHOLD) + " away from free shipping.";
        } else {
          inactiveEl.textContent = "Almost there \u2014 you're " + formatMoney(remaining) + " away from free shipping.";
        }
        inactiveEl.style.display = 'block';
      }
      if (activeEl) activeEl.style.display = 'none';
    }

    if (diffEl) diffEl.style.opacity = '1';
  }

  /* ═══════════════════════════════════════════
     RENDER SAVINGS PILLS ABOVE PACK BUTTONS
     — Absolutely positioned inside labels.
     — Does NOT move or wrap any existing DOM nodes.
     ═══════════════════════════════════════════ */

  var savingsPillConfig = {
    one_time: {
      '2': { text: 'Save $19', badge: 'Most Popular' },
      '3': { text: 'Save $38', badge: 'Best Value' }
    },
    subscribe: {
      '2': { text: 'Save $29', badge: '' },
      '3': { text: 'Save $48', badge: '' }
    }
  };

  function renderSavingsPills() {
    var cfg = savingsPillConfig[state.purchaseType] || savingsPillConfig.one_time;

    /* Clean up pills and fieldset marker from previous render */
    document.querySelectorAll('.dilemma-savings-pill').forEach(function (el) { el.remove(); });
    document.querySelectorAll('.dilemma-has-pills').forEach(function (el) { el.classList.remove('dilemma-has-pills'); });

    document.querySelectorAll('.product-form__input--pill input[type="radio"]').forEach(function (input) {
      var val = (input.value || '').trim();
      var packNum = null;
      if (/2\s*pack/i.test(val)) packNum = '2';
      else if (/3\s*pack/i.test(val)) packNum = '3';

      if (!packNum) return;

      var data = cfg[packNum];
      if (!data) return;

      var label = document.querySelector('label[for="' + input.id + '"]');
      if (!label) label = input.nextElementSibling;
      if (!label || label.tagName !== 'LABEL') return;

      /* Ensure label can anchor the absolutely-positioned pill */
      label.style.position = 'relative';
      label.style.overflow = 'visible';

      var pill = document.createElement('span');
      pill.className = 'dilemma-savings-pill';
      pill.textContent = data.badge
        ? data.text + ' \u00b7 ' + data.badge
        : data.text;

      label.appendChild(pill);

      /* Tag the parent fieldset so CSS can add top padding only here */
      var fieldset = label.closest('.product-form__input--pill');
      if (fieldset) fieldset.classList.add('dilemma-has-pills');
    });
  }

  /* ═══════════════════════════════════════════
     STATE REFRESH
     ═══════════════════════════════════════════ */

  function refreshState() {
    state.selectedPack = detectSelectedPack();
    state.purchaseType = detectPurchaseType();
    state.quantity = detectQuantity();
    state.flavorSelected = detectFlavorSelected();
    console.log('[DILEMMA DEBUG] refreshState → pack="' + state.selectedPack + '" type="' + state.purchaseType + '" qty=' + state.quantity + ' flavor=' + state.flavorSelected);
    renderPricing();
    renderPackSubPill('.dilemma-pricing__most-popular', /^2\s*pack/i);
    renderPackSubPill('.dilemma-pricing__best-value', /^3\s*pack/i);
    renderFreeShipping();
    updateAddToCartState();
    updateSupplyLabelText();
    updateProductTitle();
    updateFlavorProfile();
  }

  /* Override the "Supply:" selected-value text based on pack + purchase type.
     Variant values stay unchanged in Shopify admin — only the displayed
     summary span is rewritten here. */
  function updateSupplyLabelText() {
    var pack = state.selectedPack;
    var isSub = state.purchaseType === 'subscribe';

    /* Normalize pack state → 1 | 2 | 3 */
    var packNum = 0;
    if (pack === '1 Pack') packNum = 1;
    else if (pack === '2 Pack' || pack === '2 Pack - Save 10% (Most Popular)') packNum = 2;
    else if (pack === '3 Pack' || pack === '3 Pack - Save 15% (Best Value)') packNum = 3;

    if (!packNum) return;

    var data = pricingMap[state.selectedPack] || pricingMap['1 Pack'];
    var savings = isSub ? data.subscribeSavings : data.oneTimeSavings;

    var overrideText = null;
    if (packNum === 1) {
      overrideText = '1 UNIT (30-DAY SUPPLY)';
    } else if (savings) {
      overrideText = isSub
        ? 'Save $' + savings + ' on bundle & subscribe'
        : 'Save $' + savings + ' on bundle';
    }

    if (!overrideText) return;

    /* Identify the pack fieldset by finding a radio whose value contains
       "pack", "unit", or "supply" — covers all current variant naming. */
    var fieldsets = document.querySelectorAll('.product-form__input--pill');
    for (var i = 0; i < fieldsets.length; i++) {
      var fs = fieldsets[i];
      if (!isVisible(fs)) continue;
      var packRadio = fs.querySelector(
        'input[type="radio"][value*="pack" i], input[type="radio"][value*="unit" i], input[type="radio"][value*="supply" i]'
      );
      if (!packRadio) continue;
      var span = fs.querySelector('[data-selected-value]');
      if (span) span.textContent = overrideText;
    }
  }

  /* ═══════════════════════════════════════════
     ADD-TO-CART GUARD — disable when qty = 0
     ═══════════════════════════════════════════ */

  function updateAddToCartState() {
    var btn = document.querySelector('[id^="ProductSubmitButton"]');
    if (!btn) return;

    if (state.quantity === 0) {
      btn.setAttribute('disabled', 'disabled');
      btn.classList.add('dilemma-qty-zero');
    } else {
      // Only re-enable if it was us who disabled it (not sold-out)
      if (btn.classList.contains('dilemma-qty-zero')) {
        btn.removeAttribute('disabled');
        btn.classList.remove('dilemma-qty-zero');
      }
    }
  }

  /* Flavor color dots are handled by CSS ::before pseudo-elements
     targeting input[value*="Cucumber"] + label, etc.
     No JS needed — dots survive all theme re-renders. */

  /* ══════════════���════════════════════════════
     PACK PILL LABELS
     ═══════════════════════════════════════════ */

  function addPackLabels() {
    var labelMap = {
      'most popular': 'Most Popular',
      'best value': 'Best Value'
    };
    document.querySelectorAll('.product-form__input--pill label').forEach(function (label) {
      if (label.querySelector('.dilemma-pack-pill__label')) return;
      var text = (label.textContent || '').trim().toLowerCase();
      for (var key in labelMap) {
        if (text.indexOf(key) !== -1) {
          var originalText = label.textContent.trim();
          label.innerHTML = '';
          var wrapper = document.createElement('span');
          wrapper.className = 'dilemma-pack-pill';
          var badge = document.createElement('span');
          badge.className = 'dilemma-pack-pill__label';
          badge.textContent = labelMap[key];
          var main = document.createElement('span');
          main.textContent = originalText;
          wrapper.appendChild(badge);
          wrapper.appendChild(main);
          label.appendChild(wrapper);
          break;
        }
      }
    });
  }

  /* ═══════════════════════════════════════════
     QUANTITY OBSERVER
     ═══════════════════════════════════════════ */

  function watchQuantity() {
    // Listen for input/change on quantity fields
    document.addEventListener('input', function (e) {
      if (e.target.matches('input[name="quantity"], .quantity__input, .product-form__quantity input')) {
        setTimeout(refreshState, 30);
      }
    });
    document.addEventListener('change', function (e) {
      if (e.target.matches('input[name="quantity"], .quantity__input, .product-form__quantity input')) {
        setTimeout(refreshState, 30);
      }
    });
    // Watch for +/- button clicks (theme uses quantity-input custom element)
    // Double timeout: 50ms catches most stepUp/stepDown, 150ms catches slow renders
    document.addEventListener('click', function (e) {
      if (e.target.closest('.quantity__button, .js-qty-btn, quantity-input button, [data-quantity-btn]')) {
        setTimeout(refreshState, 50);
        setTimeout(refreshState, 150);
      }
    });
    // MutationObserver on quantity input value attribute changes
    var qtyInputs = document.querySelectorAll('input[name="quantity"], .quantity__input');
    qtyInputs.forEach(function (input) {
      var obs = new MutationObserver(function () {
        setTimeout(refreshState, 30);
      });
      obs.observe(input, { attributes: true, attributeFilter: ['value'] });
    });
  }

  /* ═══════════════════════════════════════════
     EVENT LISTENERS
     ═══════════════════════════════════════════ */

  function init() {
    refreshState();
    addPackLabels();
    watchQuantity();

    // Seal Subscriptions events
    document.addEventListener('sealsubs:subscription_widget_created', function () {
      setTimeout(refreshState, 100);
    });
    document.addEventListener('sealsubs:price_update', function () {
      setTimeout(refreshState, 50);
    });
    document.addEventListener('sealsubs:selling_plan_changed', function () {
      setTimeout(refreshState, 50);
    });

    // Variant picker changes — fire immediately + after theme DOM swap settles
    document.addEventListener('change', function (e) {
      if (e.target.closest('.product-form__input')) {
        setTimeout(refreshState, 30);
        setTimeout(refreshState, 600);
      }
    });

    // Click fallback for app blocks
    document.addEventListener('click', function (e) {
      if (e.target.closest('.shopify-app-block') || e.target.closest('[data-sealsubs]')) {
        setTimeout(refreshState, 80);
        setTimeout(refreshState, 300);
      }
    });

    // MutationObserver on app blocks
    document.querySelectorAll('.shopify-app-block').forEach(function (block) {
      var obs = new MutationObserver(function () { setTimeout(refreshState, 50); });
      obs.observe(block, { subtree: true, attributes: true, childList: true });
    });

    // Shopify native event
    document.addEventListener('variant:change', function () {
      setTimeout(refreshState, 30);
    });

    // Watch for theme viewTransition DOM swaps on variant picker parent
    var variantSelects = document.querySelector('variant-selects');
    if (variantSelects && variantSelects.parentNode) {
      var vsObs = new MutationObserver(function () {
        setTimeout(refreshState, 50);
        setTimeout(refreshState, 300);
      });
      vsObs.observe(variantSelects.parentNode, { childList: true });
    }

    // Block form submission when quantity is 0
    var productForm = document.querySelector('[data-type="add-to-cart-form"]');
    if (productForm) {
      productForm.addEventListener('submit', function (e) {
        var qty = detectQuantity();
        if (qty === 0) {
          e.preventDefault();
          e.stopPropagation();
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
